import { nanoid } from 'nanoid/non-secure';

import { USER_ID_KEY } from './constants';
import { getGlobals } from './globals';

export const handleAnonId = () => {
    let userId = window.localStorage.getItem(USER_ID_KEY);

    if (!userId) {
        // If store is cleared we can still recover the previous User ID form the global
        // variable
        const globalsUserId = getGlobals()?.anonymousId;

        userId = globalsUserId ? `${globalsUserId}` : nanoid();
        window.localStorage.setItem(USER_ID_KEY, userId);
    }

    if (typeof window !== `undefined`) {
        if (window.analytics && window.analytics.user) {
            window.analytics.user().anonymousId(userId);
        }
    }

    return userId;
};

export const getUserId = () => {
    const userId = window.localStorage.getItem(USER_ID_KEY);

    if (!userId) {
        return handleAnonId();
    }
    return userId;
};
